module.exports = __webpack_public_path__ + "img/solution-electric-function-icon-1.4bfb3bc9.svg";